uniform sampler2D uTexture;
uniform float uTime;
uniform float uProgress;
uniform vec2 uRes;
uniform vec2 uImageRes;

varying vec2 vUv;

#include ./includes/perlin3dNoise.glsl
#include ./includes/coverUV.glsl

void main()
{
    // Prevent image stretching
    vec2 newUv = CoverUV(vUv, uRes, uImageRes);

    // Displace the UV slightly
    vec2 displacedUv = vUv + cnoise(vec3(vUv * 5.0, uTime * 0.1));

    // Noise-based strength
    float strength = cnoise(vec3(displacedUv * 5.0, uTime * 0.2));

    // Add radial gradient
    float radialGradient = distance(vUv, vec2(0.5)) * 12.5 - 7.0 * uProgress;
    strength += radialGradient;

    // Clamp to 0–1
    strength = clamp(strength, 0.0, 1.0);

    // Sample the texture
    vec3 textureColor = texture2D(uTexture, newUv).rgb;

    // Opacity animation
    float opacityProgress = smoothstep(0.0, 0.7, uProgress);

    // Blend white into the edges based on strength
    vec3 finalColor = mix(vec3(1.0), textureColor, strength);

    // Alpha fades in with progress (optional)
    float alpha = opacityProgress;

    // Final color
    gl_FragColor = vec4(finalColor, alpha);
}
